import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthorizationTokenService } from 'projects/cross-study-portal-lib/src/public-api';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private auth: AuthorizationTokenService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let r = request;
    if (this.requireAuthorizationToken(r)) {
      r = r.clone({
        setHeaders: {
          Authorization: this.auth.get(),
        },
      });
    }

    return next.handle(r);
  }

  private requireAuthorizationToken(request: HttpRequest<unknown>): boolean {
    if (request.withCredentials) return false;
    // using relative path; authorization is not required
    if (!request.url.startsWith('https')) {
      return false;
    }
    return true;
  }
}
